import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';

import { useEventListener } from '@composables';
import { isNumber } from '@tools/type-guards';

export interface Props {
  range: string | number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ScrollTrigger',
  props: {
    range: null
  },
  setup(__props: any) {

const props = __props as {
  range: string | number;
};



const el = ref<HTMLDivElement | null>(null);

const triggered = ref(false);

/** ... */
const rangeValue = computed(() => {
  // ...
  const value = isNumber(props.range) ? props.range : parseFloat(props.range);

  if (value < -1 || value > 1) {
    throw new Error(
      `[ScrollTrigger] provided value "${value}" for "range" was invalid -- must be between -1 and 1.`,
    );
  }

  return value;
});

useEventListener('scroll', () => {
  if (triggered.value || !el.value) return;

  const winCenter = 0.5 * window.innerHeight;

  // ...
  const { top, height } = el.value.getBoundingClientRect();

  // ...
  const center = top + 0.5 * height;
  // ...
  const threshold = Math.min(1, Math.max(-1, (winCenter - center) / winCenter));

  if (threshold >= rangeValue.value) triggered.value = true;
});

return { __sfc: true,props, el, triggered, rangeValue }
}

})